import React from 'react';
import SectionCard from './SectionCard';
import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group';

const AfssSection = ({ submission, jsonContent, isDark }) => {
    if (submission.recipient_source === 'non-strata' || !(submission.sending === 'AFSS copy to LO' || jsonContent.sending === 'AFSS copy to LO')) {
        return null;
    }

    return (
        <SectionCard isDark={isDark}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>AFSS copy to LO</p>
            {(submission.afssCopyToLO || jsonContent.afssCopyToLO) && (
                <RadioGroup value={submission.afssCopyToLO || jsonContent.afssCopyToLO}>
                    <div className='flex flex-col gap-[14px]'>
                        {(submission.afssCopyToLO === 'Lodgement' || jsonContent.afssCopyToLO === 'Lodgement') && (
                            <div className='flex gap-[8px] items-center'>
                                <RadioGroupItem value="Lodgement" id="afss-lodgement" />
                                <label htmlFor="afss-lodgement" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                    isDark ? 'text-white' : 'text-[#072837]'
                                }`}>Lodgement</label>
                            </div>
                        )}
                        {(submission.afssCopyToLO === 'Record' || jsonContent.afssCopyToLO === 'Record') && (
                            <div className='flex gap-[8px] items-center'>
                                <RadioGroupItem value="Record" id="afss-record" />
                                <label htmlFor="afss-record" className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                    isDark ? 'text-white' : 'text-[#072837]'
                                }`}>Record</label>
                            </div>
                        )}
                    </div>
                </RadioGroup>
            )}
        </SectionCard>
    );
};

export default AfssSection;
